import { useApolloClient } from '@apollo/client'
import { InboxTaskListItemCompletionFragmentDoc } from 'generated/resources/graphql'

import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'
import { useNavigate } from 'react-router-dom'

import FormRender, { FormResourceType } from 'modules/forms/components/FormRender'

type Data = {
  formId: string
  resourceType: FormResourceType
  membershipId: string
  closePath?: string
  submitSuccessPath?: string
  taskId?: string
}

export const AnswerFormActivity: ActivityComponent<Data> = ({
  formId,
  membershipId,
  resourceType,
  closePath,
  submitSuccessPath,
  taskId,
}) => {
  const navigate = useNavigate()
  const { open, closeActivity } = useActivity()
  const apolloClient = useApolloClient()

  const handleClose = () => {
    closeActivity()

    if (closePath) {
      navigate(closePath)
    }
  }

  const handleSubmitSuccess = () => {
    if (taskId) {
      apolloClient.writeFragment({
        id: `TasksInboxTask:${taskId}`,
        fragment: InboxTaskListItemCompletionFragmentDoc,
        fragmentName: 'InboxTaskListItemCompletion',
        data: {
          __typename: 'TasksInboxTask',
          id: taskId,
          completedAt: new Date().toISOString(),
          status: 'done',
        },
      })
    }

    closeActivity()

    if (submitSuccessPath) {
      navigate(submitSuccessPath)
    }
  }

  return (
    <FormRender
      formId={formId}
      resourceType={resourceType}
      isOpen={open}
      onClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      mode="answer"
      membershipId={membershipId}
    />
  )
}
